import { Flex, Text, HStack } from '@chakra-ui/react';
import React from 'react';

import { Bank } from '@finley-technologies/finley-types';

import { FormattedStatementSummaryGQLType } from '../../../types/dashboard-core-gqlTypes.generated.d';
import { colors } from '~/packages/common-frontend/colors';
import { formatCurrencyAmount } from '~/packages/common-frontend/utils';

export const MonthlyStatementSummaryBalance = ({
  totalBalance,
  balances,
}: FormattedStatementSummaryGQLType) => {
  return (
    <>
      <Flex w="100%" pb="16px" borderBottom={`1px solid ${colors.gray[100]}`}>
        <HStack w="50%" spacing="16px">
          <Text fontWeight="bold">Statement Balance</Text>
        </HStack>
        <Text fontWeight="bold" flexGrow={1} ml="32px">
          {formatCurrencyAmount(totalBalance, Bank.Currency.USD)}
        </Text>
      </Flex>
      {balances.map(({ description, balance: accountBalance }, index) => (
        <Flex w="100%" p="24px 0px" key={description}>
          <HStack color={colors.black[70]} w="50%" spacing="16px">
            <Text>{index + 1}</Text>
            <Text>{description}</Text>
          </HStack>
          <Text color={colors.black[70]} flexGrow={1} ml="32px">
            {formatCurrencyAmount(accountBalance, Bank.Currency.USD)}
          </Text>
        </Flex>
      ))}
    </>
  );
};
